






























import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';

import formatNumber from '@/shared/filters/format-number';
import Paging from '@/shared/components/Paging.vue';

import { DATA } from '@/config/data';
import { APP_CONFIG } from '@/config/app-config';

import { SummaryDepositModel } from '@/models/summary-deposit';
import { DepositModel } from '@/models/deposit';
import Filtering from '@/shared/components/Filtering.vue';
import ListDeposit from './components/ListDeposit.vue';
import FilterBox from './components/FilterBox.vue';
import OrderFlag from "@/shared/components/OrderFlag.vue";
import depositServices from '@/services/deposit-services';
import SummaryOrder from './components/SummaryOrder.vue';
import authService from '@/services/auth-services';
import commonService from '@/services/common-services';
var FileSaver = require('file-saver');

@Component({
    components: {
        ListDeposit,
        FilterBox,
        Filtering,
        Loading,
        Paging,
        SummaryOrder,
        'order-flag-menu': OrderFlag
    }
})
export default class MainDeposit extends Vue {
    private filterProp = {
        selectedStatus: { value: -1, name: 'Tất cả', color: '#fff' },
        searchText: ''
    };
    private pageSettings = {
      rowPerPage: 15,
      pageSize: 6,
      pageIndex: 1,
      total: 0,
    };
    private flag_ids = [];
    
    private summaryOrder: SummaryDepositModel = new SummaryDepositModel();
    private listDeposit: DepositModel[] = [];
    private isLoading = false;
    private chinaAddress = '';
    private quickFilters = [];
    private filters = [];

    zeroPad = (num, places) => String(num).padStart(places, '0');

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get customerInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].customerInfo;
    }

    get warehouse() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].warehouse;
    }

    get chinaStore() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].chinaStore;
    }

    get allFlags() {
        return this.$store.state.flag.all.data;
    }

    get headers() {
        return [
            {
                text: "Order ID",
                value: "ID",
                filterable: true,
                quickSearch: true,
                dataType: DATA.DATA_TYPE["Number"]
            },
            {
                text: "Trạng thái",
                value: "Status",
                filterable: true,
                dataType: DATA.DATA_TYPE["Enum"],
                values: DATA.depositStatus
            },
            {
                text: "Ngày đặt hàng",
                value: "CreatedDate",
                filterable: true,
                dataType: DATA.DATA_TYPE["Date"]
            },
            {
                text: "Hashtag",
                value: "FlagID",
                filterable: true,
                dataType: DATA.DATA_TYPE["Enum"],
                values: this.allFlags ? this.allFlags.map(x => {
                    return {
                        'value': x.ID,
                        'name': x.FlagName
                    }
                }) : []
            }
        ]
    }

    private async getWarehouse() {
        const result = await commonService.getWarehouse();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_WAREHOUSE', result.data.data);
        }
    }

    private async getChinaStore() {
        const result = await commonService.getChinaStore();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_CHINASTORE', result.data.data);
        }
    }

    private async getCustomersInfo() {
        if (this.customerInfo && this.customerInfo.ID) {
            const result = await authService.customersInfo(this.customerInfo.ID);
            if(result && result.status === 200) {
                (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
            }
        }
    }

    private async getConfig() {
        if (this.customerInfo && this.customerInfo.ChinaStoreID) {
            const result = await commonService.getDetailChinaStore(this.customerInfo.ChinaStoreID);

            if (result && result.status === 200) {
                this.chinaAddress = `${result.data.data.Receiver}${this.zeroPad(this.customerInfo.ID, 3)} - ${result.data.data.Phone} - ${result.data.data.Address}${this.zeroPad(this.customerInfo.ID, 3)}`;
            }
        }
    }

    private async created() {
        if (!this.warehouse) {
            await this.getWarehouse();
        }
        if (!this.chinaStore) {
            await this.getChinaStore();
        }
        this.loadData();
        this.$store.dispatch("flag/getList", {'filter': [{
            column: 'CustomerTag',
            value: [1],
            condition: 'in'
        }]});
    }
    private async exportData() {
        this.isLoading = true;
        const filters: any = this.onBuildFilter();
        const res = await depositServices.exportData(filters.filters, filters.quickFilters);
        this.isLoading = false;
        let blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"});
        FileSaver.saveAs(blob, `KyGui_${new Date().getTime()}.xlsx`);
    }
    private async loadData() {
        this.isLoading = true;
        this.pageSettings.total = 0;
        const filters: any = this.onBuildFilter();
        this.summaryOrder = new SummaryDepositModel();
        this.getCustomersInfo();
        this.getConfig();
        const result = await depositServices.getDeposit(this.pageSettings.pageIndex, this.pageSettings.rowPerPage, filters.filters, filters.quickFilters);
        this.isLoading = false;
        if (result && result.data && result.data.status === 200) {
            const tmpListDeposit: DepositModel[] = [];
            this.pageSettings.total = result.data.total;
            this.summaryOrder = {
                TotalStatusAll: result.data.summary.TotalStatusAll || 0,
                TotalStatus1: result.data.summary.TotalStatus1 || 0,
                TotalStatus7: result.data.summary.TotalStatus7 || 0,
                TotalStatus9: result.data.summary.TotalStatus9 || 0,
                TotalStatus10: result.data.summary.TotalStatus10 || 0,
                TotalStatus11: result.data.summary.TotalStatus11 || 0,
                TotalStatus12: result.data.summary.TotalStatus12 || 0,
                TotalStatus16: result.data.summary.TotalStatus16 || 0,
                TotalStatus13: result.data.summary.TotalStatus13 || 0,
                TotalAmountStoreVN: result.data.summary.TotalAmountStoreVN || 0,
                TotalLeftStoreVN: result.data.summary.TotalLeftStoreVN || 0,
                TotalAmountExport: result.data.summary.TotalAmountExport || 0,
                TotalAmountExportDeposit: result.data.summary.TotalAmountExportDeposit || 0,
                TotalAmountExportNotDeposit: result.data.summary.TotalAmountExportNotDeposit || 0,
            };

            for (const item of result.data.data) {
                const deposit = new DepositModel();
                deposit.id = item.ID;
                deposit.depositCode = item.DepositCode;
                deposit.uId = item.UID;
                deposit.userName = item.Username;
                deposit.status = item.Status;
                deposit.statusDetail = DATA.depositStatus.find(x => x.value === item.Status) || { value: 0, name: 'Khác', color: '#3b4354' };
                deposit.orderWeight = item.OrderWeight;
                deposit.totalPriceVND = item.TotalPriceVND;
                deposit.createdDate = item.CreatedDate;
                deposit.ProductName = item.ProductName;
                deposit.ProductAmount = item.ProductAmount;
                deposit.ProductImage = item.ProductImage ? item.ProductImage : '';
                deposit.receivePlaceDetail = this.warehouse ? this.warehouse.find((p) => p.ID === item.ReceivePlaceID) : '';
                deposit.chinaStoreDetail = this.chinaStore ? this.chinaStore.find((p) => p.ID === item.ChinaStoreID) : '';
                tmpListDeposit.push(deposit);
            }
            this.listDeposit = tmpListDeposit;
        }
    }

    private applyFilter(data: any) {
        this.filters = data;
        this.loadData();
    }
    
    private quickFilter(data: any) {
        this.quickFilters = data;
        this.loadData();
    }

    private onBuildFilter() {
        const paramsFilter: any = {
            filters: this.filters,
            quickFilters: this.quickFilters
        };
        if(this.flag_ids.length > 0) {
            paramsFilter.filters.push({
                column: 'FlagID',
                value: this.flag_ids,
                condition: 'in'
            });    
        }
        if (this.filterProp.selectedStatus.value !== -1) {
            paramsFilter.filters.push({
                column: 'Status',
                value: this.filterProp.selectedStatus.value,
                condition: 'equal'
            });
        }

        if (this.filterProp.searchText !== null &&
            this.filterProp.searchText !== undefined &&
            this.filterProp.searchText !== '') {
                paramsFilter.quickFilters.push({
                    column: 'DepositCode',
                    value: this.filterProp.searchText,
                    condition: 'contain'
                });
                paramsFilter.quickFilters.push({
                    column: 'ID',
                    value: this.filterProp.searchText,
                    condition: 'contain'
                });
        }

        return paramsFilter;
    }

    private createNewDeposit() {
        const routeData = this.$router.resolve({ name: 'deposit-new' });
        window.open(routeData.href, '_blank');
    }
    
    private onFlagFilterChanged(data: any) {
        this.flag_ids = data.flag_ids;
        this.loadData();        
    }

    private onFilterChanged(data: any) {
        this.filterProp.selectedStatus = data.status;
        this.filterProp.searchText = data.searchText;
        this.pageSettings.pageIndex = 1;
        this.loadData();
    }

    private onChangePage(data: any) {
        this.pageSettings.pageIndex = data;
        this.loadData();
    }

    private async onCheckAll(isCheckAll: boolean) {
        this.listDeposit = this.listDeposit.map(x => {
            return {
                ...x,
                isChecked: isCheckAll
            }
        });
    }
}
